import profile from './index.vue'

export default [
  {
    path: '/profile',
    name: 'profile',
    component: profile,
    meta: {
      requiresAuth: true,
      requiresTokenAuth: true
    }
  }
]
